import { render } from "./PlaybackControls.vue?vue&type=template&id=6ac463f4&scoped=true"
import script from "./PlaybackControls.vue?vue&type=script&lang=js"
export * from "./PlaybackControls.vue?vue&type=script&lang=js"

import "./PlaybackControls.vue?vue&type=style&index=0&id=6ac463f4&lang=scss&scoped=true"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac463f4"]])

export default __exports__